import React from 'react'
import LayoutMain from '../layouts/Main'
import LayoutBase from '../layouts/Base'
import SmartFilter from '../components/SmartFilter'

export default function SmartFilterPage() {
  return (
    <LayoutBase>
      <LayoutMain>
        <SmartFilter />
      </LayoutMain>
    </LayoutBase>
  )
}
